import React, { createContext, useContext, useState } from "react"
import { DonationType } from "../types"
import { Fund } from "source/giving/donate/form/types"

type DonationHistoryContextType = {
  activeYear: number
  setActiveYear: (year: number) => void
  activeDonationType: DonationType
  setActiveDonationType: (type: DonationType) => void
  activeFund: Fund | null
  setActiveFund: (fund: Fund | null) => void
  hideNonDeductible: boolean
  setHideNonDeductible: (hide: boolean) => void
  downloadUrl: string
  setDownloadUrl: (url: string) => void
  showDownloadButton: boolean
  setShowDownloadButton: (show: boolean) => void
}

const DonationHistoryContext = createContext<
  DonationHistoryContextType | undefined
>(undefined)

export const DonationHistoryProvider = ({
  children,
  defaultYear,
}: {
  children: React.ReactNode
  defaultYear: number
}) => {
  const [activeYear, setActiveYear] = useState(defaultYear)
  const [activeDonationType, setActiveDonationType] =
    useState<DonationType>("monetary")
  const [activeFund, setActiveFund] = useState<Fund | null>(null)
  const [hideNonDeductible, setHideNonDeductible] = useState(false)
  const [downloadUrl, setDownloadUrl] = useState("")
  const [showDownloadButton, setShowDownloadButton] = useState(false)

  return (
    <DonationHistoryContext.Provider
      value={{
        activeYear,
        setActiveYear,
        activeDonationType,
        setActiveDonationType,
        activeFund,
        setActiveFund,
        hideNonDeductible,
        setHideNonDeductible,
        downloadUrl,
        setDownloadUrl,
        showDownloadButton,
        setShowDownloadButton,
      }}
    >
      {children}
    </DonationHistoryContext.Provider>
  )
}

export const useDonationHistoryContext = () => {
  const context = useContext(DonationHistoryContext)
  if (!context)
    throw new Error(
      "useDonationHistoryContext must be used within DonationHistoryProvider",
    )
  return context
}
